

export const getDateIssue = (startDate: string | null, endDate: string | null) => {
    if (!startDate && !endDate) {
        return "Duration missing";
    }
    if (!startDate) {
        return "Start date is missing";
    }
    if (!endDate) {
        return "End date is missing";
    }
    return null;
}
